// extracted by mini-css-extract-plugin
export default {"actionsDot":"Popovers_actionsDot__m90dQ","disabled":"Popovers_disabled__E7qLw","disabledIcon":"Popovers_disabledIcon__4C4kX"};